<div class="tw-p-6 tw-max-w-[1400px] tw-mx-auto">
  <div class="tw-mb-6">
    <h1 class="tw-text-[28px] tw-font-medium tw-mb-2">Workforce Insights</h1>
    <p class="tw-text-gray-600">Explore curated data insights being shared around the web</p>
  </div>

  <div class="tw-mb-6">
    <mat-form-field appearance="outline" class="tw-w-full tw-max-w-[500px]">
      <mat-label>Search posts</mat-label>
      <input
        matInput
        [(ngModel)]="searchQuery"
        (input)="onSearch()"
        placeholder="Search by title or description" />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </div>

  <div class="tw-min-h-[400px]">
    <div
      *ngIf="loading"
      class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-[60px] tw-px-5">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="tw-mt-4 tw-text-gray-600">Loading posts...</p>
    </div>

    <div
      *ngIf="!loading && filteredPosts.length === 0"
      class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-[60px] tw-px-5 tw-text-center">
      <mat-icon class="tw-text-[64px] tw-w-16 tw-h-16 tw-text-gray-300 tw-mb-4"
        >library_books</mat-icon
      >
      <p class="tw-my-2">No posts found</p>
      <p class="tw-text-sm tw-text-gray-500">
        {{ searchQuery ? 'Try a different search term' : 'Check back later for new posts' }}
      </p>
    </div>

    <div
      *ngIf="!loading && filteredPosts.length > 0"
      class="tw-grid tw-grid-cols-1 md:tw-grid-cols-[repeat(auto-fill,minmax(350px,1fr))] tw-gap-6">
      <mat-card
        *ngFor="let post of filteredPosts"
        class="tw-transition-all tw-duration-300 tw-overflow-hidden tw-flex tw-flex-col tw-h-[450px] hover:tw-translate-y-[-2px] hover:tw-shadow-lg">
        <div
          *ngIf="post.post?.imageUrl"
          class="tw-h-[200px] tw-overflow-hidden tw-m-[-16px] tw-mb-4 tw-bg-gray-100 tw-flex tw-items-center tw-justify-center">
          <img
            [src]="post.post?.imageUrl"
            [alt]="post.post?.title"
            class="tw-w-full tw-h-full tw-object-cover tw-transition-transform tw-duration-300 hover:tw-scale-105"
            (error)="handleImageError($event)" />
        </div>

        <mat-card-header class="tw-mb-3 tw-flex-shrink-0">
          <mat-card-title class="tw-text-lg tw-leading-snug">{{ post.post?.title }}</mat-card-title>
          <mat-card-subtitle class="tw-text-xs tw-mt-1">
            Created {{ formatDate(post.created_at) }}
            <span *ngIf="post.created_by"> by {{ post.created_by }}</span>
          </mat-card-subtitle>
        </mat-card-header>

        <mat-card-content class="tw-flex-1 tw-overflow-y-auto tw-pr-2 tw-mt-0 tw-mb-3">
          <p
            class="tw-text-gray-700 dark:tw-text-gray-300 tw-leading-relaxed tw-whitespace-pre-line tw-text-sm">
            {{ post.post?.description }}
          </p>
        </mat-card-content>

        <mat-card-actions
          class="tw-flex tw-justify-between tw-p-2 tw-pl-4 tw-flex-shrink-0 tw-mt-auto tw-border-0 tw-border-t tw-border-gray-500 tw-bg-transparent tw-border-solid">
          <button mat-button color="primary" (click)="openPost(post)">
            <mat-icon class="tw-text-[18px] tw-w-[18px] tw-h-[18px] tw-mr-1">visibility</mat-icon>
            View the Data
          </button>
          <button mat-button *ngIf="post.post?.link" (click)="openExternalLink($event, post)">
            <mat-icon class="tw-text-[18px] tw-w-[18px] tw-h-[18px] tw-mr-1">open_in_new</mat-icon>
            Read the Post
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
